import { NCH_ENV } from '../../../../../js/nch-env';
export default {

    data() {
        return {
            echo: null,
            is_banned: false,
            upload: null,
            messages: [],
            blacklist: [],
            roomUsers: [],
            room: {},
            message: '',
            currentRoom: '',
            forceClose: false,
            csrfToken: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            currentPage: 1,
            hasMoreMessages: true,
        };
    },
    mounted() {
        if (this.chat.room_id && this.user) {
            this.initializeEcho();
            this.joinRoom();
        }
    },
    beforeDestroy() {
        this.leaveRoom();
    },
    methods: {
        initializeEcho() {
            const channelName = `${NCH_ENV.APP_HOST}.chat.${this.chat.room_id}`;
            // console.log('Inicializando Echo, canal:', channelName);

            this.echo = window.Echo.private(channelName)
                .listen('.chat', (e) => {
                    // console.log('Evento .chat recebido:', e);
                    this.handleChatEvent(e);
                })
                .listen('chat', (e) => {
                    // console.log('Evento chat recebido:', e);
                    this.handleChatEvent(e);
                });
        },

        handleChatEvent(e) {
            // console.log('Processando evento de chat:', e);
            switch (e.action) {
            case 'join':
                // o evento vai para a sala inteira com a visão de quem entrou:
                // só quem entrou aplica (senão a entrada de outro aluno apagava
                // da tela as mensagens pendentes de quem já estava na sala)
                if (!e.user || !this.user || Number(e.user.id) === Number(this.user.id)) {
                    this.messages = e.message;
                    this.is_banned = e.user.is_banned;
                }
                this.room = e.room;
                break;
            case 'send':
                // mensagem aguardando moderação só aparece para quem enviou (backlog#340)
                if (this.isPending(e.message) && !this.isMine(e.message)) break;
                this.upsertMessage(e.message);
                if (e.message.room_id === this.currentRoom) {
                    this.seeMessage();
                }
                break;
            case 'leave':
                // Implementação específica para o caso de saída
                break;
            case 'message-status': {
                // aprovada: passa a aparecer para todos; voltou a pendente: some
                // para os demais e segue visível (marcada) para quem enviou
                const message = e.message;
                if (this.isPending(message) && !this.isMine(message)) {
                    this.messages = this.messages.filter(item => item.id !== message.id);
                } else {
                    this.upsertMessage(message);
                }
                break;
            }
            case 'user-blacklist':
                this.userBlacklist(e.blacklist);
                break;
            case 'list-users':
                this.roomUsers = e.users;
                break;
            case 'list-blacklist':
                this.blacklist = e.blacklist;
                break;
            case 'live-settings':
                this.chat.status = e.settings.chat;
                // avisa a aula (Lesson.vue) para atualizar o player e o chat sem recarregar
                this.$emit('liveSettings', {
                    settings: e.settings,
                    room: {
                        room_id: e.settings.id,
                        name: `NCH_LV_${e.settings.id}`,
                        status: e.settings.chat,
                        history: e.settings.chat_save,
                        moderate: e.settings.chat_mod,
                        type: 'lv',
                    },
                });
                break;
            case 'clean-messages':
                this.messages = [];
                break;
            default:
                // //console.log('Default:', e);
                break;
            }
            this.chatScrollDown();
        },

        /**
         * Mensagem ainda não aprovada pela moderação.
         *
         * @param {{status: number|boolean}} message
         * @returns {boolean}
         */
        isPending(message) {
            return !!message && Number(message.status) === 0;
        },

        /**
         * Mensagem enviada pelo usuário logado.
         *
         * @param {{user_id: number, user: {id: number}}} message
         * @returns {boolean}
         */
        isMine(message) {
            const owner = message && (message.user_id || (message.user && message.user.id));
            return !!this.user && Number(owner) === Number(this.user.id);
        },

        /**
         * Insere ou substitui a mensagem pelo id, mantendo a ordem de envio
         * (a mesma mensagem chega pelo retorno do envio e pelo tempo real).
         *
         * @param {{id: number}} message
         */
        upsertMessage(message) {
            if (!message || !message.id) return;
            const list = (this.messages || []).filter(item => item.id !== message.id);
            list.push(message);
            list.sort((a, b) => a.id - b.id);
            this.messages = list;
        },

        chatScrollDown() {
            setTimeout(() => {
                const $mainMessages = document.getElementById('mainMessages');
                if ($mainMessages) {
                    $mainMessages.scrollTop = $mainMessages.scrollHeight;
                    this.$store.commit('SET_WAIT', 'hide');
                }
            }, 100);
        },

        joinRoom() {
            // console.log('Entrando na sala:', this.chat.room_id);
            fetch('/chat/room/join', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                    user_id: this.user.id,
                    status: this.chat.status,
                    history: this.chat.history !== undefined ? this.chat.history : 0,
                    moderate: this.chat.moderate !== undefined ? this.chat.moderate : 0,
                    type: this.chat.type !== undefined ? this.chat.type : 'support',
                    name: this.chat.name,
                }),
            })
                .then(response => response.json())
                .then((data) => {
                    // console.log('Resposta ao entrar na sala:', data);
                    this.currentPage = 1;
                    this.listMessages(1);
                })
                .catch((error) => {
                    console.error('Error joining room:', error);
                });
        },

        leaveRoom() {
            // //console.log('Leaving room...');
            if (!this.chat || !this.chat.room_id || !this.user) return;

            fetch('/chat/room/leave', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                    user_id: this.user.id,
                }),
            })
                .then(response => response.json())
                .catch((error) => {
                    console.error('Error leaving room:', error);
                });
        },

        addMessage() {
            if (this.chat.room_id && this.user.id && (this.message !== '' || this.upload)) {
                // //console.log('Adding message...');
                fetch('/chat/room/send', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                    body: JSON.stringify({
                        room_id: this.chat.room_id,
                        user_id: this.user.id,
                        content: this.message,
                        upload_id: this.upload && this.upload.id ? this.upload.id : undefined,
                        // upload do aluno vem do upload-local (sem registro no banco):
                        // o backend cria o Upload a partir deste objeto
                        upload: this.upload && !this.upload.id ? this.upload : undefined,
                    }),
                })
                    .then(response => response.json())
                    .then((data) => {
                        // mostra a própria mensagem na hora (com moderação ela fica
                        // marcada como "aguardando aprovação" até o moderador aceitar)
                        if (data && data.id) this.upsertMessage(data);
                        this.message = '';
                        this.upload = null;
                        this.chatScrollDown();
                    })
                    .catch((error) => {
                        console.error('Error adding message:', error);
                    });
            } else {
                // //console.log('CHAT', 'Error AddMessage');
                throw new Error('Error AddMessage');
            }
        },

        seeMessage() {
            // //console.log('Setting message as read...');
            fetch('/chat/room/set-message-read', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                }),
            })
                .then(response => response.json())
                .catch((error) => {
                    console.error('Error setting message as read:', error);
                });
        },

        clear() {
            // //console.log('Clearing messages...');
            fetch('/chat/room/clean-messages', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                }),
            })
                .then(response => response.json())
                .catch((error) => {
                    console.error('Error clearing messages:', error);
                });
        },

        messageStatus({ id, status }) {
            if (this.chat.room_id && this.user.id) {
                // //console.log('Updating message status...');
                fetch('/chat/room/message-status', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                    body: JSON.stringify({
                        room_id: this.chat.room_id,
                        user_id: this.user.id,
                        message_id: id,
                        status,
                    }),
                })
                    .then(response => response.json())
                    .catch((error) => {
                        console.error('Error updating message status:', error);
                    });
            } else {
                console.error('CHAT', 'Error messageStatus');
            }
        },

        listUsers() {
            // //console.log('Listing users...');
            fetch('/chat/room/list-users', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                }),
            })
                .then(response => response.json())
                .then((data) => {
                    // //console.log('Users listed:', data);
                    this.roomUsers = data;
                })
                .catch((error) => {
                    console.error('Error listing users:', error);
                });
        },

        listBlacklist() {
            // //console.log('Listing blacklist...');
            fetch('/chat/room/black-list', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                }),
            })
                .then(response => response.json())
                .then((data) => {
                    // //console.log('Blacklist listed:', data);
                    this.blacklist = data;
                })
                .catch((error) => {
                    console.error('Error listing blacklist:', error);
                });
        },

        saveBlacklist() {
            try {
                fetch('/chat/room/black-list', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-CSRF-TOKEN': this.csrfToken,
                    },
                    body: JSON.stringify({
                        room_id: this.chat.room_id,
                        user_id: this.user.id,
                        blacklist: this.blacklist.map(({ user }) => user.id),
                        history: this.chat.history !== undefined ? this.chat.history : 0,
                        moderate: this.chat.moderate !== undefined ? this.chat.moderate : 0,
                        type: this.chat.type !== undefined ? this.chat.type : 'support',
                        name: this.chat.name,
                    }),
                })
                    .then(response => response.json())
                    .then(() => {
                        this.$store.commit('SET_NOTIFICATION', {
                            message: 'common.save_successfull',
                            status: 'success',
                        });
                    })
                    .catch((error) => {
                        console.error('Error saving blacklist:', error);
                        this.$store.commit('SET_NOTIFICATION', {
                            message: 'common.save_failure',
                            status: 'error',
                        });
                    });
            } catch (e) {
                console.error('Exception saving blacklist:', e);
                this.$store.commit('SET_NOTIFICATION', {
                    message: 'common.save_failure',
                    status: 'error',
                });
            }
        },

        listMessages(page = 1) {
            // //console.log('Listing messages...');
            fetch('/chat/room/list-messages', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': this.csrfToken,
                },
                body: JSON.stringify({
                    room_id: this.chat.room_id,
                    user_id: this.user.id,
                    page,
                }),
            })
                .then(response => response.json())
                .then((data) => {
                    // //console.log('Messages listed:', data);
                    if (page === 1) {
                        this.messages = data;
                    } else {
                        this.messages.unshift(...data);
                    }
                    if (data.length === 0 || (data.last_page && page >= data.last_page)) {
                        this.hasMoreMessages = false;
                    }
                })
                .catch((error) => {
                    console.error('Error listing messages:', error);
                });
        },

        userBlacklist(blacklist) {
            this.is_banned = !!blacklist?.find?.(user => user.id === this.user.id);
            this.$store.commit('SET_NOTIFICATION', {
                message: this.is_banned ? 'Você foi banido do chat' : 'Status atualizado',
                status: this.is_banned ? 'error' : 'success',
            });
        },
    },
};
